import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';
import { Icon } from '@mui/material';
import '../oem-data-modal.scss';

/**
 * Icon + label + value rows as a definition list, optionally under a section
 * title. A row without a value renders the N/A placeholder — callers that
 * prefer to hide absent data filter first (see the CerebrumX `present`). An
 * empty list renders nothing, title included.
 */
export const DetailList = ({ rows, title }) => {
	const { messages } = useIntl();
	if (rows.length === 0) return null;

	return (
		<section>
			{title && <h3 className="oem-section-title">{title}</h3>}
			<dl className="oem-detail-list">
				{rows.map(({ key, icon, label, value }) => (
					<Fragment key={key}>
						<dt className="oem-detail-list-label">
							{icon && <Icon fontSize="small">{icon}</Icon>}
							{label}
						</dt>
						<dd className="oem-detail-list-value">{value ?? messages['oemDataModal_notAvailable']}</dd>
					</Fragment>
				))}
			</dl>
		</section>
	);
};
